import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormLegend } from '../inputs/form-legend';
import { PLEASE_SELECT_ERROR_MESSAGE } from './form-variables';
import styles from './house-owner-section.module.scss';
import { Checkbox } from '@components/checkbox/checkbox';
import { ErrorText } from '@components/error/error-text';
import { ErrorWrapper } from '@components/error/error-wrapper';

export type HouseOwnerFormFields = {
  owner: boolean;
};

export const HouseOwnerSection: React.FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<HouseOwnerFormFields>();

  return (
    <ErrorWrapper>
      <FormLegend>Sind Sie Eigentümer/in des Hauses?</FormLegend>
      <Checkbox
        className={styles.houseDataCheckbox}
        label="Ja, ich bin Eigentümer/in."
        {...register('owner', { required: true })}
        error={Boolean(errors.owner)}
        tracking={{
          click: {
            label: 'Weiter',
            element: 'Hauseigentümerschaft',
            funnelStep: 14
          }
        }}
      />
      {errors.owner && (
        <ErrorText text={PLEASE_SELECT_ERROR_MESSAGE} className={styles.houseDataCheckboxError} />
      )}
    </ErrorWrapper>
  );
};
